window.WatchAndBuyGridInit = function (sectionId) {
  var root = document.getElementById('wabg-' + sectionId);
  var modal = document.getElementById('wab-modal-' + sectionId);
  if (!root || !modal) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll('.wab-card'));

  var video = modal.querySelector('.wab-modal-video');
  var closeBtn = modal.querySelector('.wab-modal-close');
  var backdrop = modal.querySelector('.wab-modal-backdrop');
  var muteBtn = modal.querySelector('.wab-mute-btn');
  var iconMuted = modal.querySelector('.wab-icon-muted');
  var iconUnmuted = modal.querySelector('.wab-icon-unmuted');
  var shareBtn = modal.querySelector('.wab-share-btn');
  var shareOverlay = modal.querySelector('.wab-share-overlay');
  var sharePopup = modal.querySelector('.wab-share-popup');
  var shareClose = modal.querySelector('.wab-share-close');
  var shareFacebook = modal.querySelector('.wab-share-facebook');
  var shareWhatsapp = modal.querySelector('.wab-share-whatsapp');
  var sharePinterest = modal.querySelector('.wab-share-pinterest');
  var shareCopyBtn = modal.querySelector('.wab-share-copy');
  var prevBtn = modal.querySelector('.wab-modal-prev');
  var nextBtn = modal.querySelector('.wab-modal-next');
  var productCard = modal.querySelector('.wab-product-card');
  var productAvatar = modal.querySelector('.wab-product-avatar');
  var productVendor = modal.querySelector('.wab-product-vendor');
  var productPrice = modal.querySelector('.wab-product-price');
  var productCompare = modal.querySelector('.wab-product-compare');
  var productDiscount = modal.querySelector('.wab-product-discount');

  var currentIndex = 0;

  function formatMoney(cents) {
    if (!cents) return '';
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    return 'PKR ' + amount;
  }

  function openCard(index) {
    var card = cards[index];
    if (!card) return;
    currentIndex = index;

    var videoSrc = card.getAttribute('data-video');
    var poster = card.getAttribute('data-poster');
    var label = card.getAttribute('data-label');
    var price = card.getAttribute('data-price');
    var comparePrice = card.getAttribute('data-compare-price');
    var url = card.getAttribute('data-url');
    var avatar = card.getAttribute('data-avatar');

    if (videoSrc) {
      video.src = videoSrc;
      video.poster = poster || '';
      video.muted = true;
      iconMuted.style.display = '';
      iconUnmuted.style.display = 'none';
      video.play().catch(function () {});
    }

    productVendor.textContent = label || '';
    productAvatar.src = avatar || poster || '';

    if (price) {
      productPrice.textContent = formatMoney(price);
    } else {
      productPrice.textContent = '';
    }

    if (comparePrice && price && parseInt(comparePrice, 10) > parseInt(price, 10)) {
      productCompare.textContent = formatMoney(comparePrice);
      var discount = Math.round((1 - (price / comparePrice)) * 100);
      productDiscount.textContent = '-' + discount + '%';
      productCompare.style.display = '';
      productDiscount.style.display = '';
    } else {
      productCompare.style.display = 'none';
      productDiscount.style.display = 'none';
    }

    productCard.href = url || '#';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    video.pause();
    video.removeAttribute('src');
    video.load();
    document.body.style.overflow = '';
    closeSharePopup();
  }

  cards.forEach(function (card, index) {
    var btn = card.querySelector('.wab-card-btn');
    btn.addEventListener('click', function () {
      openCard(index);
    });
  });

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') openCard((currentIndex + 1) % cards.length);
    if (e.key === 'ArrowLeft') openCard((currentIndex - 1 + cards.length) % cards.length);
  });

  prevBtn.addEventListener('click', function () {
    openCard((currentIndex - 1 + cards.length) % cards.length);
  });
  nextBtn.addEventListener('click', function () {
    openCard((currentIndex + 1) % cards.length);
  });

  muteBtn.addEventListener('click', function () {
    video.muted = !video.muted;
    iconMuted.style.display = video.muted ? '' : 'none';
    iconUnmuted.style.display = video.muted ? 'none' : '';
  });

  function openSharePopup() {
    var url = productCard.href;
    var title = productVendor.textContent || document.title;

    if (shareFacebook) {
      shareFacebook.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    }
    if (shareWhatsapp) {
      shareWhatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);
    }
    if (sharePinterest) {
      sharePinterest.href = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&description=' + encodeURIComponent(title);
    }

    shareOverlay.classList.add('is-open');
    sharePopup.classList.add('is-open');
    sharePopup.setAttribute('aria-hidden', 'false');
  }

  function closeSharePopup() {
    shareOverlay.classList.remove('is-open');
    sharePopup.classList.remove('is-open');
    sharePopup.setAttribute('aria-hidden', 'true');
    if (shareCopyBtn) {
      shareCopyBtn.textContent = 'Copy Link';
      shareCopyBtn.classList.remove('is-copied');
    }
  }

  shareBtn.addEventListener('click', openSharePopup);
  if (shareClose) shareClose.addEventListener('click', closeSharePopup);
  if (shareOverlay) shareOverlay.addEventListener('click', closeSharePopup);

  if (shareCopyBtn) {
    shareCopyBtn.addEventListener('click', function () {
      var url = productCard.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          shareCopyBtn.textContent = 'Copied!';
          shareCopyBtn.classList.add('is-copied');
        });
      } else {
        var temp = document.createElement('input');
        temp.value = url;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
        shareCopyBtn.textContent = 'Copied!';
        shareCopyBtn.classList.add('is-copied');
      }
    });
  }
};
